import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";
import { buildUrlQuery } from "@builder/utils/buildUrlQuery";
import { Customer } from "@builder/types/Customer.type";

export const customersApi = createApi({
    reducerPath: "customersApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}customer`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["customers"],
    endpoints: builder => ({
        getCustomers: builder.query<Customer[], { companyId: string; search?: string; offset?: number; limit?: number; organizationId?: string }>({
            query: ({ companyId, ...query }) => `/builder/query/${companyId}?${buildUrlQuery(query)}`,
            providesTags: ["customers"]
        }),
        getCustomersByIds: builder.query<Customer[], { companyId: string; ids: string[]; organizationId?: string }>({
            query: ({ companyId, ids }) => `/builder/by-ids/${companyId}?ids=${ids.join(",")}`,
            providesTags: ["customers"]
        })
    })
});

export const { useGetCustomersQuery, useGetCustomersByIdsQuery } = customersApi;
